import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_gift_wrapping: FaireCategoryEntity = {
  token: "catalog_cat_gift-wrapping",
  type: "category",
  name: "Gift wrapping",
  count: 7,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
